import { Link } from 'react-router-dom'
import './Home.css'

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1>AI 시대의 문해력 혁신</h1>
            <p className="hero-subtitle">
              NEXPA는 AI 기반 문해력 평가 플랫폼으로, 지식의 미래를 새롭게 설계합니다.
            </p>
            <div className="hero-buttons">
              <Link to="/products" className="btn btn-outline">플랫폼 보기</Link>
              <Link to="/contact" className="btn btn-outline">문의하기</Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <div className="container">
          <div className="about-content">
            <h2 className="section-title">우리는 미래의 지식을 설계합니다</h2>
            <div className="about-text">
              <p>
                NEXPA는 초등부터 성인까지 전 생애 주기에 걸친 문해력 증진을 목표로,<br />
                AI 기술과 게임화 전략을 결합한 독창적인 평가 시스템을 개발하고 있습니다.
              </p>
              <p className="highlight">
                교육을 기술로, 기술을 새로운 경험으로 이어가는 것이 우리의 미션입니다.
              </p>
              
              {/* LIDIA Banner */}
              <div className="lidia-banner-inline">
                <a 
                  href="https://lidia.nexpa-ai.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="banner-link-inline"
                >
                  <div className="banner-card">
                    <h3>Nexpa LIDIA</h3>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2 className="section-title">핵심 서비스</h2>
          <div className="services-grid">
            <div className="service-card card">
              <div className="service-icon">📘</div>
              <h3>LIDIA Literacy System</h3>
              <ul className="service-features">
                <li>AI 기반 문항 생성 및 맞춤형 독서 평가</li>
                <li>단계별 독서 게임과 실시간 피드백</li>
                <li>인증서 발급 및 성향 분석 리포트</li>
              </ul>
            </div>
            
            <div className="service-card card">
              <div className="service-icon">🌐</div>
              <h3>NEXPA MAP</h3>
              <ul className="service-features">
                <li>게임 결과 기반 지식 확장 맵 제공</li>
                <li>다양한 주제·분야별 시각적 학습 도구</li>
              </ul>
            </div>
            
            <div className="service-card card">
              <div className="service-icon">🎓</div>
              <h3>NEXPA Edu 플랫폼</h3>
              <div className="coming-soon">개발 예정</div>
              <ul className="service-features">
                <li>파트너 교육기관 및 콘텐츠 연계 시스템</li>
                <li>출판사 제휴 기반 콘텐츠 확장</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision">
        <div className="container">
          <h2 className="section-title">Our Vision</h2>
          <div className="vision-content">
            <h3>세상을 읽는 힘, 문해력을 혁신합니다</h3>
            <div className="vision-grid">
              <div className="vision-item">
                <h4>AI 기반 독서 이해력 진단 및 피드백 시스템</h4>
              </div>
              <div className="vision-item">
                <h4>학습 데이터 기반 맞춤형 학습 여정 제공</h4>
              </div>
              <div className="vision-item">
                <h4>글로벌 확산 가능한 다국어 평가 콘텐츠 구축</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section className="solutions">
        <div className="container">
          <h2 className="section-title">Solution</h2>
          <div className="solutions-grid">
            <div className="solution-item">📘 Nexpa LIDIA</div>
            <div className="solution-item">📙 LIDIA Elementary</div>
            <div className="solution-item">📗 LIDIA Teen</div>
            <div className="solution-item">📕 LIDIA Classic</div>
            <div className="solution-item">📔 LIDIA Select 100</div>
          </div>
        </div>
      </section>

      {/* Partnership Section */}
      <section className="partnership">
        <div className="container">
          <div className="partnership-content card">
            <h2>제휴 및 파트너십 안내</h2>
            <p>
              넥스파는 다양한 파트너사와 협업을 확대하고 있습니다.<br />
              기술 제휴 및 콘텐츠 협력에 관심 있는 기관은 아래 연락처로 문의해주세요.
            </p>
            <Link to="/contact" className="btn btn-primary">파트너십 문의</Link>
          </div>
        </div>
      </section>

      {/* NEXPA MAP Section */}
      <section className="nexpa-map-section">
        <div className="container">
          <h2 className="section-title">NEXPA MAP</h2>
          
          <div className="map-gallery">
            <div className="map-item">
              <img src="/nexpa-map1.png" alt="NEXPA MAP 1" />
            </div>
            <div className="map-item">
              <img src="/nexpa-map2.png" alt="NEXPA MAP 2" />
            </div>
            <div className="map-item">
              <img src="/nexpa-map3.png" alt="NEXPA MAP 3" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home 